module.exports = __webpack_public_path__ + "static/media/HtmlImage.11cb386c.svg";